import React, {Component} from 'react';
import spacetime from 'spacetime/immutable';
import {Trans} from '@lingui/macro';

import {extractTranslatedLabel, formatDate} from '../../services/utilities';

import WelcomeUser from '../WelcomeUser';
import TestItemIcon from '../TestItemIcon';

import cl from 'classnames';
import s from './Dashboard.css';

function renderDate(date) {
  const UTCDate = date + 'Z';
  return formatDate(UTCDate, 'dd.MM.yyyy HH:mm');
}

const MAX_PROGESS = 99;

function getTimeProgress(startDate, endDate) {
  const start = startDate && spacetime(startDate);
  const end = endDate && spacetime(endDate);
  if (!start || !end) {
    return 0;
  }
  const deltaTot = end.epoch - start.epoch;
  const now = spacetime.now();
  const deltaNow = end.epoch - now.epoch;
  let delta = deltaTot - deltaNow;
  if (delta < 0) {
    delta = 0;
  }

  return Math.max(Math.min(Math.round((delta / deltaTot) * 100), MAX_PROGESS), 0);
}

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.dashboardRef = React.createRef();
    this.state = this.makeNewState(props);
  }

  makeNewState = props => {
    const challengeStatus = Math.round((props.completedTests.size / props.testsList.size) * 100);

    return {
      challengeStatus: Number.isNaN(challengeStatus) ? 0 : challengeStatus,
    };
  };

  componentWillReceiveProps(nextProps) {
    this.setState(() => this.makeNewState(nextProps));
  }

  render() {
    const {userName, testsList, completedTests, userCampaign, lang} = this.props;
    const {challengeStatus} = this.state;
    const description = userCampaign.get('description') || '';
    let onCompleteText = userCampaign.get('onCompleteText') || '';
    const delta = testsList
      .map(t => t.get('id'))
      .toSet()
      .subtract(completedTests.map(t => t.get('id')).toSet());
    const isComplete = delta.size === 0 && completedTests.size > 0;
    const timeProgress = getTimeProgress(
      userCampaign.get('dateStart'),
      userCampaign.get('dateEnd')
    );

    return (
      <div className={s.Dashboard} ref={this.dashboardRef}>
        <WelcomeUser userName={userName || 'guest'} />
        <div className={s.Intro}>
          {isComplete && onCompleteText ? (
            <div className={s.Subtitle} dangerouslySetInnerHTML={{__html: onCompleteText}} />
          ) : (
            description && (
              <div className={s.Subtitle} dangerouslySetInnerHTML={{__html: description}} />
            )
          )}
          <div className={s.IntroElement}>
            <p className={s.Titles}>
              <Trans id="dashboard.completed_tests">Prove Completate</Trans>
            </p>
            <div className={s.Results}>
              <div className={s.CompletedTests}>
                <span className={s.Number}>{completedTests.size}</span>
                <span className={s.NumberSeparator}>
                  <Trans id="dashboard.out_of">su</Trans>
                </span>
                <span className={s.Number}>{testsList.size}</span>
              </div>
              <div className={s.Tests}>
                {completedTests.map(item => {
                  const name = extractTranslatedLabel(item, lang, 'name');

                  return (
                    <TestItemIcon
                      key={item.get('id')}
                      size={45}
                      iconLabel={item.get('abbreviation') || name.substr(0, 2).toUpperCase()}
                      className={s.TestItemIcon}
                      status={item.get('status')}
                    />
                  );
                })}
              </div>
            </div>
          </div>
          <div className={s.IntroElement}>
            <p className={s.Titles}>
              <Trans id="dashboard.advancement">Avanzamento</Trans>
            </p>
            <div className={s.DueDate}>
              <svg className={s.pie} viewBox="0 0 32 32">
                <defs>
                  <linearGradient id="mygradient">
                    <stop offset="5%" className={s.StartColor} />
                    <stop offset="95%" className={s.StopColor} />
                  </linearGradient>
                </defs>
                <circle
                  className={s.circle}
                  fill="url(#mygradient)"
                  r="16"
                  cx="16"
                  cy="16"
                  style={{strokeDasharray: `${challengeStatus} 100`}}
                />
                <circle className={s.insideCirle} r="12" cx="16" cy="16" />
              </svg>
              <span className={s.Number} style={{marginLeft: '1em'}}>
                {challengeStatus}%
              </span>
            </div>
          </div>
          {userCampaign.get('dateEnd') && (
            <div className={s.IntroElement}>
              <p className={s.Titles}>
                <Trans id="dashboard.end_date.">Scadenza</Trans>
              </p>
              <div className={cl(s.DueDate, s.BarContainer)}>
                <span className={s.Date}>{renderDate(userCampaign.get('dateEnd'))}</span>
                {userCampaign.get('dateStart') && (
                  <div
                    className={cl(
                      s.ProgressBar,
                      timeProgress >= MAX_PROGESS && s.ProgressBar_Complete
                    )}
                  >
                    <span
                      className={s.ProgressBar__Bar}
                      style={{
                        width: `${timeProgress}%`,
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}
export default Dashboard;
